import React from 'react'
import Header from '../Components/Header'
import Sidebar from '../Components/Sidebar'
import QueryDisplay from './QueryDisplay'

const Query = () => {
    return (
        <div id="dashboard-root"
            className="flex min-h-[1000px] w-full">
            {/* <!-- Sidebar --> */}
            <Sidebar />
            {/* <!-- Main Content --> */}
            <main id="main-content" className="flex-1 px-10 py-8">
                {/* <!-- Header --> */}
                <Header title="Inquery" />
                <QueryDisplay />
            </main>

        </div>
    )
}

export default Query
